__webpack_require__.p = "/WordPuzzle/";